<div class="table-responsive">
  <table class="table table-hover" *ngIf="modalidadeAceita && composicaoGarantia && !outrasGarantias">
    <thead>
      <tr>
        <th scope="col">Tipo de garantia</th>
      <tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <select class="form-select" id="composicaoGarantia" name="composicaoGarantia"
            [disabled]="true">
            <option [value]="garantia.codigo" [selected]="codigoComposicaoGarantia && codigoComposicaoGarantia == garantia.codigo"
              *ngFor="let garantia of composicaoGarantia">
              {{garantia.codigo}} - {{garantia.nome}}</option>
          </select>

        </td>
      </tr>
    </tbody>
  </table>
  <table class="table table-hover" *ngIf="modalidadeAceita && principalGarantiaOperacao && !outrasGarantias">
    <thead>
      <tr>
        <th scope="col">Principal garantia da operação</th>
      <tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <select class="form-select" id="principalGarantiaOperacao" name="principalGarantiaOperacao"
            [disabled]="true">
            <option [value]="garantia.codigo" [selected]="codigoPrincipalGarantiaOperacao && codigoPrincipalGarantiaOperacao == garantia.codigo"
              *ngFor="let garantia of principalGarantiaOperacao">
              {{garantia.codigo}} - {{garantia.nome}}</option>
          </select>
        </td>
      </tr>
    </tbody>
  </table>
  <table class="table table-hover" *ngIf="modalidadeAceita && percentualCobertoGarantiaPrincipal && !outrasGarantias">
    <thead>
      <tr>
        <th scope="col">Percentual coberto pela principal garantia</th>
      <tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <input type="text" class="form-control" value="{{percentualCobertoGarantiaPrincipal | bnMask:'DECIMAL': '2'}}" disabled />
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="table-responsive" *ngIf="outrasGarantias; else carregando">
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Tipo de garantia *</th>
        <tr>
      </thead>
      <tbody>
        <tr *ngFor="let gart of outrasGarantias; let i = index">
          <td>
            <span *ngIf="modoEdicao || emInclusao"><a (click)="removerGarantia(i)"><i
                  class="fa fa-trash cursor-pointer"></i></a></span>
          </td>
          <td>
            <select class="form-select" id="tipoGarantia" name="tipoGarantia"
              (change)="atribuiGarantia($event.target.value, i)" required
              [disabled]="!modoEdicao && !emInclusao">
              <option [value]="undefined" [selected]="!gart || !gart.tipoGarantia">(selecione um tipo de
                garantia)</option>
              <option [value]="tiposGart.id" [selected]="gart && gart.tipoGarantia == tiposGart.id"
                *ngFor="let tiposGart of dadosDominio?.tiposOutrasGarantias">
                {{tiposGart.id}} - {{tiposGart.nome}}</option>
            </select>

          </td>
        </tr>
      </tbody>
    </table>
    <a (click)="adicionarGarantia()" *ngIf="modoEdicao || emInclusao"><i
        class="fa fa-plus-circle cursor-pointer"></i></a>
  </div>


<ng-template #carregando>
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>